import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { KeyValueMap, LoggingService, WindowService } from "@merri/common";
import { Observable } from "rxjs";
import { HelperMethods } from "src/app/shared/helper-methods";
import { AppConfigService } from "../services";

@Injectable({
  providedIn: "root",
})
export class HeadersInterceptor implements HttpInterceptor {
  constructor(private appConfigService: AppConfigService, private windowService: WindowService) {
    LoggingService.log("HeadersInterceptor ctor");
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this._addHeaders(request);

    return next.handle(request);
  }

  private _addHeaders(request: HttpRequest<any>): HttpRequest<any> {
    if (!request.url.startsWith(this.appConfigService.getConfig().baseApiUrl)) {
      return request;
    }

    return request.clone({
      setHeaders: this.getHeaders(),
    });
  }

  private getHeaders(): KeyValueMap<string> {
    const headers = {};
    headers["Web-Session-Id"] = this.appConfigService.sessionId ?? "N/A";
    headers["Web-App-Version"] = this.appConfigService.appVersion ?? "N/A";
    headers["Web-Browser-Location"] = this.appConfigService.location ?? "N/A";
    headers["Web-Client"] =
      `Width=${HelperMethods.getWindowWidth()};` +
      `Height=${HelperMethods.getWindowHeight()};` +
      `IsMobile=${HelperMethods.isMobile()};` +
      `IsSmallScreen=${this.windowService.isSmallScreen()};` +
      `IsOneTimeSmallScreen=${this.windowService.isOneTimeSmallScreen()};`;

    return headers;
  }
}
